

export interface RouteMap {
    url: string;
    title: string;
    requiresAuth: boolean;
}

export const ROUTE_NAME_HOME_LANDING = "Home";
export const ROUTE_NAME_LOGIN = "Login";
export const ROUTE_NAME_DASHBOARD = "Dashboard";
export const ROUTE_NAME_WIZARD = "Wizard";
export const ROUTE_NAME_HELP = "Help";


const routes: RouteMap[] = [
  { url: "/", title: ROUTE_NAME_HOME_LANDING, requiresAuth: false },
  { url: "/login", title: ROUTE_NAME_LOGIN, requiresAuth: false },
  { url: "/dashboard", title: ROUTE_NAME_DASHBOARD, requiresAuth: true },
  { url: "/wizard/{id}", title: ROUTE_NAME_WIZARD, requiresAuth: true },
  { url: "/help", title: ROUTE_NAME_HELP, requiresAuth: true }
];

export default routes;